<template>
  <instructions-components
    class="pointer-events-auto midder"
    :header="$t('instructions')"
    :button-text="$t('continue')"
    :cards="getInstructions"
    show-button
    @button-click="closeInstructions"
  />
</template>

<script lang="ts">
import { Instructions } from '@powerplay/core-minigames-ui'
import {
  CorePhases,
  corePhasesManager,
  modes,
  tutorialManager
} from '@powerplay/core-minigames'
import { pathAssets } from '@/globals/globalvariables'
import { defineComponent } from 'vue'
import { blurState } from '@/stores'

export default defineComponent({
  name: 'InstructionComponent',
  components: {
    InstructionsComponents: Instructions
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  emits: ['close-instructions'],
  computed: {
    getInstructions(): {imgSrc: string, header: string, text: string[]}[] {

      blurState().isActive = true

      if (modes.isTrainingMode()) {

        return [
          {
            imgSrc: `${pathAssets}/ui/instructions/instructions-1.png?3`,
            header: this.$t('instructionsDisciplineTraining5Cell1Title'),
            text: [this.$t('instructionsDisciplineTraining5Cell1Text1')]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/instructions-2.png?3`,
            header: this.$t('instructionsDisciplineTraining5Cell2Title'),
            text: [this.$t('instructionsDisciplineTraining5Cell2Text1')]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/instructions-3.png?3`,
            header: this.$t('instructionsDisciplineTraining5Cell3Title'),
            text: [this.$t('instructionsDisciplineTraining5Cell3Text1')]
          }
        ]

      }

      return [
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-1.png?3`,
          header: this.$t('instructionsDiscipline5Cell1Title'),
          text: [this.$t('instructionsDiscipline5Cell1Text1')]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-2.png?3`,
          header: this.$t('instructionsDiscipline5Cell2Title'),
          text: [this.$t('instructionsDiscipline5Cell2Text1')]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-3.png?3`,
          header: this.$t('instructionsDiscipline5Cell3Title'),
          text: [this.$t('instructionsDiscipline5Cell3Text1')]
        }
      ]

    }
  },
  methods: {
    closeInstructions(): void {

      // pokial mame prvotne instrukcie, tak ich zavrieme
      if (corePhasesManager.isActivePhaseByType(CorePhases.instructions)) {

        corePhasesManager.getActualPhase()?.finishPhase()

      }
      this.$emit('close-instructions')
      tutorialManager.blockInputsManually()

    }
  }
})
</script>

<style lang="less" scoped>
</style>
